import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Report from './Report'
// import ReactDOM from 'react-dom';
import LoaderWrapper from './loaderWrapper'
import { fetchReport } from '../../api'

const ORIGINAL_STATS = [
	'Marketers named social media as the #1 most difficult channel to execute.',
	'87% of marketers perceive social advertising data ownership as important.',
	'Nearly 60% of marketers have partial to no transparency into how their social advertising campaigns performed.',
	'Social advertising investments are expected to double over the next 5 years.'
]

export default class ReportLoader extends Component {
	constructor(props) {
		super(props)
		this.state = {
			stats: ORIGINAL_STATS.sort(() => Math.random() - 0.5),
			statsIndex: 0
		}
	}

	fetchReport = async () => {
		let {match, facebookSession, sessionEmail, exitReport, history, reportLoaded, activeAccount: {name}} = this.props
		const start = Date.now()
		const data = await fetchReport(match.params.accountId, facebookSession.accessToken, sessionEmail, name)
		if(!data) {
			window.mixpanel.track('[AdScore] - Report Load Error', {
				adAccountID: match.params.accountId
			})
			history.push('/accounts/err')
			exitReport()
			return
		} else {
			setTimeout(
				() => {
					reportLoaded(data.report, data.request_time)
				},
				4000 - (Date.now() - start)
			)
			clearInterval(this.timerID)
		}
	}

	componentDidMount() {
		if(!this.props.facebookSession || !this.props.match.params.accountId) {
			// Redirect them to the homepage
			this.props.history.push('/')
		} else {
			// Only fetch the report if one hasn't been loaded
			if(!this.props.report) {
				this.timerID = setInterval(
					() => this.rotateStat(),
					2500
				)
				this.fetchReport()
			}
		}
	}

	componentWillUnmount() {
		clearInterval(this.timerID)
	}

	rotateStat() {
		this.setState({
			statsIndex: this.state.statsIndex + 1
		})
	}

	render() {
		let { stats, statsIndex } = this.state
		let { activeAccount, exitReport, report, reportLoadTime, sessionEmail, history, match, facebookSession, adMonitorRequested, adMonitorRequests } = this.props
		
		if (report) {
			return (
				<Report
					report={report}
					accountName={activeAccount.name}
					exitReport={exitReport}
					sessionEmail={sessionEmail}
					history={history}
					accountId={match.params.accountId}
					facebookSession={facebookSession}
					reportLoadTime={reportLoadTime}
					adMonitorRequested={adMonitorRequested}
					adMonitorRequests={adMonitorRequests} />
			)
		} else {
			return (
				<LoaderWrapper>
					<h1>{stats[(statsIndex % stats.length)]}</h1>
				</LoaderWrapper>
			)
		}
	}
}

ReportLoader.propTypes = {
	accountId: PropTypes.string,
	facebookSession: PropTypes.object,
	history: PropTypes.object,
	match: PropTypes.object,
	exitReport: PropTypes.func,
	activeAccount: PropTypes.object,
	sessionEmail: PropTypes.string,
	adMonitorRequests: PropTypes.object,
	adMonitorRequested: PropTypes.func,
	reportLoaded: PropTypes.func,
	report: PropTypes.object,
	reportLoadTime: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/index.js